<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="小程序appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="小程序名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="accountName"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooser(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { appletlistrw } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfonone: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getprogramlist()
    },
    // 获取绑定列表
    async getprogramlist() {
      const data = await appletlistrw(this.pageIfonone)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonone.pageSize = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageIfonone.page = e
      this.getprogramlist()
    },
    chooser(row) {
      console.log('row', row)
      this.$emit('callback', row)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
